import React from 'react';
import { Grid, IconButton } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';
import { Card1, Card2 } from 'components/Card';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SaibaMais = () => {
    const { isMobile } = useDevice();
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <Grid container
            style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-around',
                maxHeight: isMobile ? '100%' : '100%',
                fontFamily: 'Open sans',
                flexDirection: isMobile ? 'column' : '',
                margin: isMobile ? '' : '2em 0 5em'
            }}>
            <Grid item xs={12}>
                <IconButton onClick={handleBack} style={{ position: '', top: 20, left: 20, zIndex: 999 }}>
                    <ArrowBackIcon style={{ color: 'var(--azul)' }} />
                </IconButton>
            </Grid>
            <Grid item xs={12} md={5} xl={4} lg={5}
                style={{
                    textAlign: 'justify',
                    padding: isMobile ? '2em 2em' : '',
                    fontSize: isMobile ? '12px' : '16px',
                }}>
                {/* <h1
                    style={{
                        color: 'var(--azul)',
                        fontSize: '1.6em',
                        fontWeight: 600
                    }}>Destinação Diretamente ao Fundo</h1> */}
                <p>
                O Fundo da Infância e Adolescência, também conhecido como Fundo de Direitos da Criança e do Adolescente, é um fundo especial previsto na lei 4.320/1964, sendo um importante mecanismo de gestão e captação de recursos com a finalidade de garantir a sustentabilidade da política de atendimento dos direitos da criança e do adolescente.
                </p>
                <p>
                São várias as fontes de receita do FIA, mas o art. 260 do ECA faz clara menção a uma das mais potentes, as destinações de parte o imposto de renda devido: os contribuintes poderão efetuar doações aos Fundos, sendo essas integralmente deduzidas do imposto de renda, obedecidos os limites.
                </p>


            </Grid>

            <Grid item xs={12} md={5} xl={4} style={{
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <Card1 />
                <Card2 />
            </Grid>
        </Grid>
    )
}

export default SaibaMais;
